<!--
    描述：公共页面 --- 项目信息页面
    时间：2021-03-29
    Created by 王帅
-->
<template>
	<div class="project-info-main content-layout">
		<el-card v-for="(item, index) in cardShowList"
				 :key="'card' + index"
				 class="info-card">
			<!-- 标题 -->
			<div slot="header"
				 class="info-card-header"
				 @click="item.showContent = !item.showContent">
				<span class="card-header-icon"><i :class="
              item.showContent ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
            "></i></span>
				<span>{{ `#${index + 1} ${item.title}` }}</span>
			</div>

			<!-- 内容 -->
			<div class="info-content"
				 v-show="item.showContent">
				<!-- 项目信息 -->
				<template v-if="item.attr === 'baseInfo'">
					<el-form ref="projectForm"
							 :model="projectInfo"
							 size="small"
							 :disabled="infoDisabled"
							 label-width="200px">
						<el-row>
							<el-col :span="12">
								<el-form-item label="项目名称"
											  prop="sname"
											  :rules="requiredRule">
									<el-input v-model="projectInfo.sname"
											  placeholder="请输入项目名称"
											  clearable
											  maxlength="50"
											  show-word-limit
											  class="s-input"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目编号"
											  prop="proNo">
									<el-input v-model="projectInfo.proNo"
											  placeholder="项目编号自动生成"
											  :disabled="true"
											  clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目类型"
											  prop="newProType"
											  :rules="requiredRule">
									<el-select v-model="projectInfo.newProType"
											   placeholder="请选择项目类型"
											   size="small">
										<el-option v-for="item in projectDict.dxxmlx"
												   :key="item.id"
												   :label="item.sname"
												   :value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="建设类型"
											  prop="constructionType"
											  :rules="requiredRule">
									<el-select placeholder="请选择"
											   v-model="projectInfo.constructionType"
											   size="small">
										<el-option v-for="item in projectDict.dxjslx"
												   :key="item.id"
												   :value="item.value"
												   :label="item.sname"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="建设单位"
											  prop="constructionUnit"
											  :rules="requiredRule">
									<el-select placeholder="请选择"
											   v-model="projectInfo.constructionUnit"
											   size="small"
											   :disabled="routeQuery == 'edit'"
											   @change="constUnitChange">
										<el-option v-for="item in jsUnit"
												   :key="item.ownerUnit"
												   :value="item.ownerUnit"
												   :label="item.sname"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="建设任务书编号"
											  prop="assignNo"
											  v-if="projectInfo.hasSerial === 1"
											  :rules="requiredRule">
									<el-input placeholder="请填写任务书编号"
											  maxlength="30"
											  show-word-limit
											  v-model="projectInfo.assignNo"></el-input>
								</el-form-item>
								<el-form-item label="无任务书编号原因"
											  prop="reason"
											  :rules="requiredRule"
											  v-else>
									<el-input maxlength="100"
											  show-word-limit
											  v-model="projectInfo.reason"
											  placeholder="请填写无任务书编号原因"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="2"
									class="text-right mt5">
								<el-checkbox v-model="projectInfo.hasSerial"
											 :true-label="0"
											 :false-label="1">暂无编号</el-checkbox>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目归属区域"
											  prop="isNorth"
											  :rules="requiredRule">
									<el-select placeholder="请选择"
											   v-model="projectInfo.isNorth"
											   size="small"
											   :disabled="routeQuery == 'edit'"
											   @change="areaChange">
										<el-option v-for="item in projectDict.xmgsqy"
												   :key="item.id"
												   :value="item.value"
												   :label="item.sname"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form :model="projectInfo"
										 size="small"
										 label-width="200px">
									<el-form-item label="项目位置"
												  prop="address"
												  :rules="requiredRule">
										<el-col :span="4">
											<el-button plain
													   size="small"
													   icon="el-icon-location"
													   class="custom-disabled w100"
													   @click="location"
													   :disabled="false">地图定位</el-button>

										</el-col>
										<el-col :span="20">
											<el-input v-model="projectInfo.address"
													  placeholder="请输入项目位置"
													  clearable
													  maxlength="100"
													  show-word-limit
													  class="special-input"></el-input>
										</el-col>
									</el-form-item>
								</el-form>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目年份"
											  prop="proYear"
											  :rules="requiredRule">
									<el-date-picker type="year"
													v-model="projectInfo.proYear"
													format="yyyy"
													value-format="yyyy"
													placeholder="请选择项目年份"
													clearable></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目造价区间"
											  prop="intervalPrice"
											  :rules="requiredRule">
									<el-select v-model="projectInfo.intervalPrice"
											   placeholder="请选择区间"
											   clearable>
										<el-option v-for="(item, index) in projectDict.xmzjqj"
												   :key="index"
												   :label="item.sname"
												   :value="item.value"
												   :disabled="item.disabled"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="计划开工时间"
											  prop="planStartTime"
											  :rules="requiredRule">
									<el-date-picker v-model="projectInfo.planStartTime"
													type="date"
													placeholder="选择日期"
													@change="timeChange">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="计划竣工时间"
											  prop="planEndTime"
											  :rules="requiredRule">
									<el-date-picker v-model="projectInfo.planEndTime"
													type="date"
													:picker-options="endDatePicker"
													placeholder="选择日期">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="争取开工年份"
											  prop="striveStartDate"
											  :rules="requiredRule">
									<el-date-picker v-model="projectInfo.striveStartDate"
													type="year"
													placeholder="请选择"
													format="yyyy"
													value-format="yyyy"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="建设规模及内容"
											  prop="projectSurvey"
											  :rules="requiredRule">
									<el-input type="textarea"
											  placeholder="请输入内容"
											  maxlength="500"
											  show-word-limit
											  v-model="projectInfo.projectSurvey"
											  :autosize="{ minRows: 6 }">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="长度"
											  prop="length"
											  :rules="projectInfo.lengthSign ? numberRule : []">
									<el-input v-model="projectInfo.length"
											  placeholder="请输入"
											  maxlength="10"
											  show-word-limit
											  :disabled="!projectInfo.lengthSign">
										<template slot="append">米</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="2"
									class="text-right mt5">
								<el-checkbox v-model="projectInfo.lengthSign"
											 :true-label="0"
											 :false-label="1"
											 @change="noContent('length')">暂无此内容</el-checkbox>
							</el-col>
							<el-col :span="10">
								<el-form-item label="建筑面积"
											  prop="floorage"
											  :rules="projectInfo.floorageSign ? numberRule : []">
									<el-input v-model="projectInfo.floorage"
											  placeholder="请输入"
											  maxlength="10"
											  show-word-limit
											  :disabled="!projectInfo.floorageSign">
										<template slot="append">平方米</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="2"
									class="text-right mt5">
								<el-checkbox v-model="projectInfo.floorageSign"
											 :true-label="0"
											 :false-label="1"
											 @change="noContent('floorage')">暂无此内容</el-checkbox>
							</el-col>
							<el-col>
								<el-form :model="projectInfo"
										 size="small"
										 label-width="200px">
									<el-form-item label="项目封面">
										<myUpload list-type="list"
												  ref="coverUpload"
												  :createUser="userInfo.sname"
												  :createCompany="upUnit"
												  :shortName="shortName"
												  tableName="bus_project"
												  assortment="cover_file"
												  width="auto"
												  height="auto"
												  :maxNum="1"
												  :fileSize="2"
												  :aid="projectInfo.id"
												  :isDisabled="false"
												  uploadType="99"
												  :acceptType="['PNG', 'JPG', 'JPEG']"></myUpload>
									</el-form-item>
								</el-form>
							</el-col>
						</el-row>
					</el-form>
				</template>

				<!-- 项目费用 -->
				<template v-if="item.attr === 'projectMoney'">
					<el-form ref="projectMoneyForm"
							 :model="moneyForm"
							 size="small"
							 label-width="200px">
						<el-row :gutter="10"
								style="border-bottom: none">
							<el-col :span="24">
								<el-form-item label-width="110px">
									项目投资（无费用，可填写0）
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目总投资"
											  prop="proTotalValue"
											  :rules="moneyRule">
									<el-input v-model="moneyForm.proTotalValue"
											  placeholder="请输入"
											  clearable
											  min="0"
											  type="number"
											  disabled>
										<template slot="append">万元</template>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :span="12"
									v-for="(item, index) in moneyForm.feeTr"
									:key="'feeTr' + index">
								<el-form-item :label="item.feeDictName"
											  :rules="moneyRule"
											  :prop="`feeTr.${index}.feeValue`">
									<el-col :span="16">
										<el-input v-model="item.feeValue"
												  placeholder="请输入"
												  min="0"
												  type="number"
												  @input="trMoneyChange">
											<template slot="append">万元</template>
										</el-input>
									</el-col>
									<el-col :span="8">
										<el-input v-model="item.percent"
												  placeholder="占项目总投资比重"
												  disabled>
											<template slot="append">%</template>
										</el-input>
									</el-col>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="10"
								style="border-bottom: none">
							<el-col :span="24"
									class="border-top">
								<el-form-item label-width="110px">
									项目资金来源（无费用，可填写0）
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目总来源资金"
											  prop="proTotalInvestment"
											  :rules="moneyRule">
									<el-input v-model="moneyForm.proTotalInvestment"
											  placeholder="请输入"
											  clearable
											  min="0"
											  type="number"
											  disabled>
										<template slot="append">万元</template>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="10">
							<el-col :span="12"
									v-for="(item, index) in moneyForm.feeLy"
									:key="'feeLy' + index"
									:offset="item.value == '1097001' ? 0 : 0">
								<el-form-item :label="item.feeDictName"
											  :rules="moneyRule"
											  :prop="`feeLy.${index}.feeValue`">
									<el-col :span="16">
										<el-input v-model="item.feeValue"
												  placeholder="请输入"
												  min="0"
												  type="number"
												  @input="lyMoneyChange">
											<template slot="append">万元</template>
										</el-input>
									</el-col>
									<el-col :span="8">
										<el-input v-model="item.percent"
												  placeholder="占项目总投资比重"
												  disabled>
											<template slot="append">%</template>
										</el-input>
									</el-col>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</template>

				<!-- 业主单位 -->
				<template v-if="item.attr === 'owner'">
					<el-form ref="ownerForm"
							 :model="ownerInfo"
							 :rules="ownerRules"
							 size="small"
							 label-width="200px"
							 class="padding10">
						<el-row v-for="(item, index) in ownerInfo.ownerUnitItem"
								:key="'ownerUnitItem' + index"
								class="border-style">
							<el-col :span="12">
								<el-form-item :label="item.limitName"
											  :prop="'ownerUnitItem.' + index + '.tenantId'"
											  :rules="item.require ? [{ required: true, message: '不能为空...' }] : []">
									<el-select v-model="item.tenantId"
											   placeholder="请选择"
											   clearable
											   filterable
											   :disabled="item.disabled"
											   @clear="clearCompany(index)"
											   @change="companyChange($event,item.limitName,index)">
										<el-option v-for="(item, index1) in filterCompany(item.limitName)"
												   :key="index1"
												   :label="item.sname"
												   :value="item.ownerUnit"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="单位类型"
											  :prop="'ownerUnitItem.' + index + '.limitName'">
									<el-select v-model="item.limitName"
											   placeholder="请选择"
											   clearable
											   disabled>
										<el-option v-for="(item, index) in projectDict.dwlx"
												   :key="index"
												   :label="item.sname"
												   :value="item.value"
												   :disabled="item.disabled"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="item.limitName + '项目负责人'"
											  :rules="item.require ? [{ required: true, message: '不能为空...' }] : []"
											  :prop="'ownerUnitItem.' + index + '.userId'">
									<el-select v-model="item.userId"
											   placeholder="请选择"
											   :clearable="index === 1 ? false : true"
											   @clear="clearPerson(index)"
											   @change="userChange($event,index)"
											   :disabled="item.disabled">
										<el-option v-for="(item, index) in getUserList(item.userList)"
												   :key="index"
												   :label="item.sname"
												   :value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="item.limitName + '负责人联系方式'"
											  :rules="item.require ? requiredRule : []"
											  :prop="'ownerUnitItem.' + index + '.phone'">
									<el-input v-model="item.phone"
											  placeholder="请选择"
											  clearable
											  disabled></el-input>
								</el-form-item>
							</el-col>
							<template v-if="index == 0">
								<el-col :span="12">
									<el-col :span="projectInfo.id && roleBtns.includes('changAdmin') ? 20 : 24">
										<el-form-item label="项目管理员"
													  :rules="requiredRule"
													  :prop="'ownerUnitItem.' + index + '.adminId'">
											<el-select v-model="item.adminId"
													   placeholder="请选择"
													   ref="adminInput"
													   clearable
													   :disabled="item.adminDisabled"
													   @clear="clearAdmin(index)"
													   @change="userChangeAdmin($event,index)">
												<el-option v-for="(item, index) in getUserList(item.userList)"
														   :key="index"
														   :label="item.sname"
														   :value="item.id"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="4"
											v-if="projectInfo.id && roleBtns.includes('changAdmin')">
										<el-button size="small"
												   type="success btn-success"
												   class="ml5 w100"
												   style="min-width:92px"
												   @click="changAdmin(item)"
												   v-if="roleBtns.includes('changAdmin')">更换管理员</el-button>
									</el-col>
								</el-col>
								<el-col :span="12">
									<el-form-item label="项目管理员联系方式"
												  :rules="item.require ? requiredRule : []"
												  :prop="'ownerUnitItem.' + index + '.adminPhone'">
										<el-input v-model="item.adminPhone"
												  placeholder="请选择"
												  clearable
												  disabled></el-input>
									</el-form-item>
								</el-col>
							</template>
						</el-row>
					</el-form>
					<el-button class="btn-success mt15"
							   size="small"
							   icon="el-icon-plus"
							   @click="addUnitDialog">新增参建单位信息</el-button>
					<vxe-table :data="showUnitList"
							   resizable
							   border
							   align="center"
							   header-align="center"
							   row-id="tenantId"
							   class="mt15"
							   show-overflow
							   show-header-overflow>
						<vxe-table-column field="limitName"
										  title="单位类型"></vxe-table-column>
						<vxe-table-column field="sname"
										  title="单位名称"></vxe-table-column>
						<vxe-table-column field="leaderName"
										  title="项目人员"></vxe-table-column>
						<vxe-table-column field="phone"
										  title="联系方式"></vxe-table-column>
						<vxe-table-column field="postName"
										  title="职务"></vxe-table-column>
						<vxe-table-column field="roleName"
										  title="项目角色"></vxe-table-column>
						<vxe-table-column title="操作">
							<template #default="{ row, rowIndex }">
								<el-button class="table-btn"
										   type="danger"
										   round
										   plain
										   icon="el-icon-remove-outline"
										   :class="{ 'is-disabled': row.roleId }"
										   @click="removePerson(row,rowIndex)">移除人员
								</el-button>
							</template>
						</vxe-table-column>
					</vxe-table>
				</template>

				<!-- 项目资料 -->
				<template v-if="item.attr === 'projectData'"
						  v-loading="dataTableObj.loading">
					<div class="text-right btnGroups mb10">
						<el-select placeholder="请选择"
								   v-model="curLevel"
								   @change="changeLevel"
								   size="small">
							<el-option v-for="n in maxLevel"
									   :key="'level' + n"
									   :value="n"
									   :label="`展开到${n}级`"></el-option>
						</el-select>
					</div>
					<vxe-table ref="dataTable"
							   :data="dataTableObj.tableData"
							   resizable
							   border
							   :loading="dataTableObj.loading"
							   row-id="templateId"
							   :tree-config="{children: 'children'}"
							   show-overflow
							   show-header-overflow>
						<vxe-table-column title="序号"
										  align="left"
										  width="80"
										  type="seq">
						</vxe-table-column>
						<vxe-table-column title="资料清单"
										  field="sname"
										  align="left"
										  tree-node
										  min-width="300">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.remark"
											:disabled="row.level == 0 || row.level == 1"
											placement="top">
									<span>{{ row.sname }}</span>
								</el-tooltip>
							</template>
						</vxe-table-column>
						<vxe-table-column title="附件"
										  field="fileName"
										  align="center"
										  min-width="200">
							<template #default="{ row }">
								<span class="vxe-table--cell blue-text"
									  v-if="row.fileList.length > 0"
									  @click="addData(row, 'view')">
									查看（共{{ row.fileList.length }} 个文件）
								</span>
								<span v-else>-</span>
							</template>
						</vxe-table-column>
						<vxe-table-column field="upFlag"
										  title="是否需要上传"
										  align="center"
										  width="150">
							<template #default="{ row }">
								<div v-if="row.level == 2 || row.level == 3">{{ row.upFlag === 1 ? '是' : '否' }}</div>
								<div v-else>-</div>
							</template>
						</vxe-table-column>
						<vxe-table-column title="操作"
										  align="center"
										  width="250">
							<template #default="{ row, rowIndex }">
								<el-button size="small"
										   type="primary"
										   class="table-btn mr10"
										   round
										   plain
										   v-if="row.upFlag === 1"
										   icon="el-icon-upload2"
										   :disabled="row.noSuchContent === 1"
										   @click="addData(row, 'add')">上传
								</el-button>
								<el-checkbox v-if="row.level == 2 || row.level == 3"
											 :disabled="row.fileList.length > 0"
											 v-model="row.noSuchContent"
											 :true-label="1"
											 :false-label="0"
											 @change="contentChange(row)">暂无此内容</el-checkbox>
							</template>
						</vxe-table-column>
					</vxe-table>
				</template>

				<!-- 标段信息 -->
				<template v-if="item.attr === 'sectionInfo'">
					<div class="box-header">
						<el-button class="btn-success"
								   size="small"
								   icon="el-icon-plus"
								   :loading="btnLoading"
								   @click="handleSection('add')">新增标段</el-button>
					</div>
					<vxe-table ref="sectionTable"
							   :data="sectionTableObj.tableData"
							   :loading="sectionTableObj.loading"
							   resizable
							   border
							   show-overflow
							   show-header-overflow>
						<vxe-table-column title="序号"
										  align="center"
										  width="80"
										  type="seq">
						</vxe-table-column>
						<vxe-table-column title="标段编号"
										  field="packNo"
										  align="center"
										  width="180"></vxe-table-column>
						<vxe-table-column title="标段名称"
										  field="sname"
										  header-align="center"
										  align="left"
										  min-width="180">
							<template #default="{ row }">
								<span class="vxe-cell--label blue-text"
									  @click="viewSection(row)">
									{{ row.sname }}
								</span>
							</template>
						</vxe-table-column>
						<vxe-table-column title="标段负责人"
										  field="packPrincipalName"
										  align="center"
										  width="120">
						</vxe-table-column>
						<vxe-table-column title="标段类型"
										  field="packTypeName"
										  align="center"
										  width="120">
						</vxe-table-column>
						<vxe-table-column title="合同工期"
										  field="duration"
										  align="center"
										  width="120">
						</vxe-table-column>
						<vxe-table-column title="标段预算金额（万元）"
										  field="buget"
										  header-align="center"
										  align="right"
										  width="180">
						</vxe-table-column>
						<vxe-table-column title="标段内容建设与规模"
										  field="content"
										  header-align="center"
										  align="left"
										  min-width="200">
						</vxe-table-column>
						<vxe-table-column title="操作"
										  align="center"
										  width="170">
							<template #default="{ row, rowIndex }">
								<el-button size="small"
										   type="success"
										   class="table-btn"
										   round
										   plain
										   @click="handleSection('edit', row)">
									<svg-icon icon-class="form-edit"></svg-icon> 编辑
								</el-button>
								<el-button size="small"
										   type="danger"
										   class="table-btn"
										   round
										   plain
										   :disabled="row.state === '1'"
										   @click="handleSection('delete', row)">
									<svg-icon icon-class="form-delete"></svg-icon> 删除
								</el-button>
							</template>
						</vxe-table-column>
					</vxe-table>
				</template>

				<template v-if="item.attr === 'logData'">
					<vxe-table border
							   align="center"
							   :data="logData"
							   highlight-current-row
							   highlight-hover-row
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-table-column field=""
										  title="操作时间"></vxe-table-column>
						<vxe-table-column field=""
										  title="操作人员"></vxe-table-column>
						<vxe-table-column field=""
										  title="日志详情"></vxe-table-column>
						<vxe-table-column field=""
										  title="说明"></vxe-table-column>
					</vxe-table>
				</template>
			</div>
		</el-card>

		<!-- 弹窗管理 -->
		<el-dialog :visible.sync="dialogObj.visible"
				   :title="dialogObj.title"
				   :width="dialogObj.width"
				   center
				   :top="dialogObj.type == 'section' ? '7vh' : '15vh'"
				   :class="{ elHeight:dialogObj.type == 'section' }"
				   @closed="doCancel"
				   :close-on-click-modal="false">
			<!-- 添加资料弹窗 -->
			<template v-if="dialogObj.type === 'file'">
				<p class="mb10"
				   v-if="dialogObj.mode == 'add'">请将需要上传的文件在此窗口一次性操作完毕，窗口关闭后之前上传的文件将会被覆盖</p>
				<myUpload list-type="table"
						  ref="fileUpload"
						  :createUser="userInfo.sname"
						  :createCompany="upUnit"
						  :shortName="shortName"
						  tableName="bus_project"
						  assortment="project_file"
						  :aid="dataTableObj.currentId"
						  :isDisabled="dialogObj.mode == 'view'"
						  :mode="dialogObj.mode"
						  :uploadType="dialogObj.mode == 'view' ? '' : '0'"
						  getForm="audit"
						  @loadingFalse="dialogObj.btnLoading = false"></myUpload>
			</template>

			<!-- 新增标段弹窗 -->
			<template v-if="dialogObj.type === 'section'">
				<el-form ref="sectionForm"
						 :model="sectionForm"
						 size="small"
						 label-width="200px">
					<el-collapse v-model="activeCollapse"
								 class="custom-collapse">
						<el-collapse-item title="#1 标段信息"
										  name="1">
							<el-row>
								<el-col :span="12">
									<el-form-item label="标段编号"
												  prop="packNo">
										<el-input v-model="sectionForm.packNo"
												  placeholder="标段编号自动生成"
												  disabled
												  clearable>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段名称"
												  prop="sname"
												  :rules="requiredRule">
										<el-input v-model="sectionForm.sname"
												  placeholder="请输入标段名称"
												  :maxlength="50"
												  show-word-limit
												  clearable
												  :disabled="sectionForm.state == '1'"
												  class="s-input"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段(包)类型"
												  prop="packType"
												  :rules="requiredRule">
										<el-select v-model="sectionForm.packType"
												   placeholder="请选择标段(包)类型"
												   :disabled="sectionForm.state == '1'"
												   clearable>
											<el-option v-for="(item, index) in projectDict.bdlx"
													   :key="index"
													   :label="item.sname"
													   :value="item.value"
													   :disabled="item.disabled"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="合同工期"
												  prop="duration"
												  :rules="requiredRule">
										<el-input v-model="sectionForm.duration"
												  placeholder="请输入合同工期"
												  clearable
												  type="number"
												  class="moneyNum"
												  maxlength="5"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">天</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段负责人"
												  prop="packPrincipal"
												  :rules="requiredRule">
										<el-select v-model="sectionForm.packPrincipal"
												   placeholder="请选择"
												   clearable
												   :disabled="sectionForm.state == '1'"
												   @change="userChange1">
											<el-option v-for="(item, index) in personList"
													   :key="index"
													   :label="item.sname"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段负责人联系方式"
												  prop="constract"
												  :rules="requiredRule">
										<el-input v-model="sectionForm.constract"
												  placeholder="请选择标段负责人联系方式"
												  clearable
												  disabled></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段预算金额"
												  prop="buget"
												  :rules="noRequiredMoneyRule">
										<el-input v-model="sectionForm.buget"
												  placeholder="请输入标段预算金额"
												  clearable
												  type="number"
												  title=""
												  class="moneyNum money-input-inner"
												  maxlength="10"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段建安工程概算价"
												  prop="estimatePrice"
												  :rules="noRequiredMoneyRule">
										<el-input v-model="sectionForm.estimatePrice"
												  placeholder="请输入标段建安工程概算价"
												  clearable
												  type="number"
												  title=""
												  class="moneyNum money-input-inner"
												  maxlength="10"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="招标控制价"
												  prop="controlPrice"
												  :rules="moneyRule">
										<el-input v-model="sectionForm.controlPrice"
												  placeholder="请输入招标控制价"
												  clearable
												  type="number"
												  title=""
												  class="moneyNum money-input-inner"
												  maxlength="10"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="预备金/暂列金"
												  prop="reservePrice"
												  :rules="noRequiredMoneyRule">
										<el-input v-model="sectionForm.reservePrice"
												  placeholder="请输入预备金/暂列金"
												  clearable
												  type="number"
												  title=""
												  class="moneyNum money-input-inner"
												  maxlength="10"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="合同价"
												  prop="contractPrice"
												  :rules="moneyRule">
										<el-input v-model="sectionForm.contractPrice"
												  placeholder="请输入合同价"
												  clearable
												  type="number"
												  title=""
												  class="moneyNum money-input-inner"
												  maxlength="10"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="中标价"
												  prop="bidPrice"
												  :rules="moneyRule">
										<el-input v-model="sectionForm.bidPrice"
												  placeholder="请输入中标价"
												  clearable
												  type="number"
												  title=""
												  class="moneyNum money-input-inner"
												  maxlength="10"
												  :disabled="sectionForm.state == '1'"
												  show-word-limit>
											<template slot="append">万元</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="标段(包)内容建设与规模"
												  prop="content"
												  :rules="requiredRule">
										<el-input v-model="sectionForm.content"
												  type="textarea"
												  placeholder="请输入标段(包)内容建设与规模"
												  :maxlength="500"
												  show-word-limit
												  :disabled="sectionForm.state == '1'"
												  :autosize="{ minRows: 8 }"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="备注说明"
												  prop="remark">
										<el-input v-model="sectionForm.remark"
												  type="textarea"
												  placeholder="请输入备注说明"
												  :maxlength="500"
												  show-word-limit
												  :disabled="sectionForm.state == '1'"
												  :autosize="{ minRows: 8 }"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</el-collapse-item>
						<el-collapse-item title="#2 标段关联单位"
										  name="2"
										  class="custom-row-section">
							<el-row>
								<el-col :span="12">
									<el-form-item label="跟踪协审单位"
												  prop="GZSJDW.tenantId">
										<el-select v-model="sectionForm.GZSJDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('GZSJDW')">
											<el-option v-for="item in getUnit(sectionForm.GZSJDW.limitId, 'GZSJDW')"
													   :key="item.tenantId + 'GZSJDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="跟踪协审单位负责人"
												  prop="GZSJDW.adminUser">
										<el-select v-model="sectionForm.GZSJDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('GZSJDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.GZSJDW.tenantId, 'GZSJDW')"
													   :key="item.userId + 'GZSJDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="跟踪协审单位工程师"
												  prop="GZSJDW.userId">
										<el-select v-model="sectionForm.GZSJDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.GZSJDW.tenantId)"
													   :key="item.userId + 'GZSJDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="结算协审单位"
												  prop="JSSJDW.tenantId">
										<el-select v-model="sectionForm.JSSJDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('JSSJDW')">
											<el-option v-for="item in getUnit(sectionForm.JSSJDW.limitId, 'JSSJDW')"
													   :key="item.tenantId + 'JSSJDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="结算协审单位负责人"
												  prop="JSSJDW.adminUser">
										<el-select v-model="sectionForm.JSSJDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('JSSJDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.JSSJDW.tenantId, 'JSSJDW')"
													   :key="item.userId + 'JSSJDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="结算协审单位工程师"
												  prop="JSSJDW.userId">
										<el-select v-model="sectionForm.JSSJDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.JSSJDW.tenantId)"
													   :key="item.userId + 'JSSJDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="三方巡查单位"
												  prop="SFXCDW.tenantId">
										<el-select v-model="sectionForm.SFXCDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('SFXCDW')">
											<el-option v-for="item in getUnit(sectionForm.SFXCDW.limitId, 'SFXCDW')"
													   :key="item.tenantId + 'SFXCDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="三方巡查单位负责人"
												  prop="SFXCDW.adminUser">
										<el-select v-model="sectionForm.SFXCDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('SFXCDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.SFXCDW.tenantId, 'SFXCDW')"
													   :key="item.userId + 'SFXCDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="三方巡查单位工程师"
												  prop="SFXCDW.userId">
										<el-select v-model="sectionForm.SFXCDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.SFXCDW.tenantId)"
													   :key="item.userId + 'SFXCDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="设计单位">
										<el-select v-model="sectionForm.SJDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('SJDW')">
											<el-option v-for="item in getUnit(sectionForm.SJDW.limitId, 'SJDW')"
													   :key="item.tenantId + 'SJDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="设计单位负责人">
										<el-select v-model="sectionForm.SJDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('SJDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.SJDW.tenantId, 'SJDW')"
													   :key="item.userId + 'SJDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="设计单位工程师">
										<el-select v-model="sectionForm.SJDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.SJDW.tenantId)"
													   :key="item.userId + 'SJDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="监理单位">
										<el-select v-model="sectionForm.JLDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('JLDW')">
											<el-option v-for="item in getUnit(sectionForm.JLDW.limitId, 'JLDW')"
													   :key="item.tenantId + 'JLDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="监理单位负责人">
										<el-select v-model="sectionForm.JLDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChangee('JLDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.JLDW.tenantId, 'JLDW')"
													   :key="item.userId + 'JLDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="监理单位工程师">
										<el-select v-model="sectionForm.JLDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.JLDW.tenantId)"
													   :key="item.userId + 'JLDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="施工单位">
										<el-select v-model="sectionForm.SGDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('SGDW')">
											<el-option v-for="item in getUnit(sectionForm.SGDW.limitId, 'SGDW')"
													   :key="item.tenantId + 'SGDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="施工单位负责人">
										<el-select v-model="sectionForm.SGDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('SGDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.SGDW.tenantId, 'SGDW')"
													   :key="item.userId + 'SGDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="施工单位工程师">
										<el-select v-model="sectionForm.SGDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.SGDW.tenantId)"
													   :key="item.userId + 'SGDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="咨询单位">
										<el-select v-model="sectionForm.ZXDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('ZXDW')">
											<el-option v-for="item in getUnit(sectionForm.ZXDW.limitId, 'ZXDW')"
													   :key="item.tenantId + 'ZXDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="咨询单位负责人">
										<el-select v-model="sectionForm.ZXDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('ZXDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.ZXDW.tenantId, 'ZXDW')"
													   :key="item.userId + 'ZXDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="咨询单位工程师">
										<el-select v-model="sectionForm.ZXDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.ZXDW.tenantId)"
													   :key="item.userId + 'ZXDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="主管单位">
										<el-select v-model="sectionForm.ZGDW.tenantId"
												   placeholder="请选择"
												   clearable
												   @change="sectionChange('ZGDW')">
											<el-option v-for="item in getUnit(sectionForm.ZGDW.limitId, 'ZGDW')"
													   :key="item.tenantId + 'ZGDW'"
													   :label="item.sname"
													   :value="item.tenantId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="主管单位负责人">
										<el-select v-model="sectionForm.ZGDW.adminUser"
												   placeholder="请选择"
												   @change="adminUserChange('ZGDW')">
											<el-option v-for="item in getUnitPerson(sectionForm.ZGDW.tenantId, 'ZGDW')"
													   :key="item.userId + 'ZGDW' + 'person'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="主管单位工程师">
										<el-select v-model="sectionForm.ZGDW.userIds"
												   multiple
												   placeholder="请选择">
											<el-option v-for="item in getUnitPerson(sectionForm.ZGDW.tenantId)"
													   :key="item.userId + 'ZGDW' + 'userIds'"
													   :label="item.leaderName"
													   :value="item.userId"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
						</el-collapse-item>
					</el-collapse>
				</el-form>
			</template>

			<div slot="footer"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   class="btn"
						   @click="doCancel">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   class="btn btn-success"
						   @click="doSubmit('0')"
						   v-if="dialogObj.type == 'section'"
						   :disabled="sectionForm.state == '1'"
						   :loading="dialogObj.btnLoading">暂 保 存</el-button>
				<el-button type="primary"
						   size="small"
						   class="btn"
						   @click="doSubmit('1')"
						   :loading="dialogObj.btnLoading">{{ dialogObj.type == 'section' ? '提 交' : '确 定' }}</el-button>
			</div>
		</el-dialog>

		<!-- 保存、取消按钮 -->
		<div class="right-btns">
			<el-button size="mini"
					   @click="backHome">取消</el-button>
			<el-button size="mini"
					   class="btn-blue"
					   :loading="btnLoading"
					   @click="doSave('save')">保存</el-button>
		</div>

		<!-- 查看标段信息 -->
		<SectionLook v-if="sectionShow"
					 ref="SectionLook"
					 :sectionId="sectionId"></SectionLook>

		<!-- 添加参建单位 -->
		<AddUnit v-if="addUnitShow"
				 ref="addUnit"
				 :selectData="ownerInfo.ownerUnitItem"
				 @sendPerson="acceptPerson"
				 @diaclose="acceptClose"
				 :showUnit="showUnitList"></AddUnit>

		<!-- 地图定位 -->
		<el-dialog title="地图定位"
				   :visible.sync="locationShow"
				   width="1200px"
				   center
				   top="4vh"
				   :close-on-click-modal="false"
				   :before-close="locationClose"
				   lock-scroll
				   :destory-on-close="true">
			<div style="height: 680px">
				<ProjectAddMap ref="ProjectMapIndex"
							   v-if="locationShow"
							   @sendPoint="acceptPoint"></ProjectAddMap>
			</div>
			<div slot="footer">
				<el-button class="btn"
						   @click="locationBtn(false)">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   @click="locationBtn(true)">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import AddressForm from 'components/addressForm/addressForm'
import dayjs from 'dayjs'
import * as Api from 'api/projectManage/ProjectIndex'
import * as UploadApi from 'api/upload/upload'
import { getUserTenantTablePageListByTenantId } from 'api/system/sysUserTenant'
import { mapState } from 'vuex'
import { $deepCopy } from 'utils/tools.js'
import SectionLook from '@/views/Common/SectionLook'
import AddUnit from '@/views/Common/AddUnit'
import ProjectAddMap from '@/views/ProjectMap/ProjectAddMap'

export default {
	name: 'ProjectInfo',
	components: {
		AddressForm,
		SectionLook,
		AddUnit,
		ProjectAddMap,
	},
	data() {
		return {
			// 全部的 card 数组
			cardList: [
				{
					title: '项目信息',
					attr: 'baseInfo',
					showContent: true,
				},
				{
					title: '项目费用',
					attr: 'projectMoney',
					showContent: true,
				},
				{
					title: '参建单位信息',
					attr: 'owner',
					showContent: true,
				},
				{
					title: '标段信息',
					attr: 'sectionInfo',
					showContent: true,
				},
				{
					title: '项目资料',
					attr: 'projectData',
					showContent: true,
				},
				{
					title: '操作日志',
					attr: 'logData',
					showContent: true,
				},
			],
			btnLoading: false,
			infoDisabled: false,
			// 项目信息表单
			projectInfo: {
				id: undefined,
				auditId: undefined,
				sname: undefined, //工程项目名称
				proNo: undefined, //项目编号
				buildUnitName: undefined, //总包施工单位
				buildPrincipal: undefined, //建设单位项目负责人
				constract: undefined, //标段负责人联系方式
				area: '', //项目所在区域
				isNorth: undefined, // 南北区
				hasSerial: 1, // 有无编号 （1 有编号  0无编号）
				reason: undefined,
				address: undefined, //项目地址
				newProType: undefined, //项目类型
				proYear: undefined, //项目年份
				branchUnit: undefined, //分管部门
				status: undefined, //项目状态
				intervalPrice: undefined, //项目造价区间
				assignNo: undefined, //建设任务书编号
				controlPrice: undefined, //招标控制价
				contract: undefined, //联系方式
				settle: undefined, //结算价
				planStartTime: '', //计划开工时间
				planEndTime: '', //计划竣工时间
				striveStartDate: '', //争取开工年份
				totalBuget: '', //项目总概算价
				projectSurvey: '', // 建设规模及内容
				constructionUnit: '', //建设单位
				constructionType: '', //建设类型
				length: '', //长度
				lengthSign: 1, //暂无此内容(长度) 0 暂无 1：有
				floorage: '', //建筑面积(平方米)
				floorageSign: 1, //暂无此建筑面积(平方米) 0 暂无 1：有	(平方米)
			},
			currentArea: '',
			moneyForm: {
				proTotalValue: 0, //项目总投资
				proTotalInvestment: 0, //项目总来源资金
				feeTr: [], //项目投入
				feeLy: [], // 项目费用来源
			},
			acceptType: ['PNG', 'JPG', 'JPEG'],
			// 业主单位表单
			ownerInfo: {
				ownerUnit: undefined,
				unitAddress: undefined,
				creditCode: undefined,
				unitType: undefined,
				unitLinker: undefined,
				contract: undefined,
				ownerUnitItem: [
					{
						tenantId: '',
						limitName: '建设单位',
						limitId: '',
						userId: '',
						userList: [],
						phone: '',
						require: true,
						adminId: '', //项目管理员id
						adminName: '', // 项目管理员名称
						adminPhone: '', //项目管理员号码
						isNewUserId: 1, //是不是新增
						isSelect: 1,
					},
					{
						tenantId: '',
						limitName: '代建单位',
						limitId: '',
						userId: '',
						userList: [],
						phone: '',
						require: false,
						isNewUserId: 1, //是不是新增
						isSelect: 1,
					},
				],
			},
			ownerRules: {
				unitLinker: [{ required: true, message: '请输入单位联系人' }],
				contract: [{ required: true, message: '请输入联系方式' }],
			},
			companyList: [], //公司列表
			// 项目资料
			curLevel: 1,
			maxLevel: 1, // 最大level
			dataTableObj: {
				tableData: [], // 表格数据
				currentId: '',
				loading: false,
				curTemplateId: '',
			},
			// 文件列表
			fileList: [],
			tableName: '', // 文件表名
			fileDialog: {
				visible: false,
				btnLoading: false,
			},
			// 标段信息
			sectionTableObj: {
				loading: false,
				tableData: [], // 表格数据
			},
			activeCollapse: ['1', '2'],
			sectionForm: {
				projectId: undefined, //项目ID
				auditId: undefined, //子项目ID
				packNo: undefined, //标段编号
				sname: undefined, //标段名称
				packType: '', // 标段类型
				duration: '', //合同工期
				packPrincipal: undefined, //项目标段负责人
				oldPackPrincipal: undefined, //项目标段负责人
				constract: undefined, //标段负责人联系方式
				buget: undefined, //标段预算金额
				estimatePrice: undefined, //标段建安工程概算价
				controlPrice: undefined, //招标控制价
				reservePrice: undefined, //预备金/暂列金
				bidPrice: undefined, //中标价
				contractPrice: undefined, //合同价
				content: undefined, //标段(包)内容建设与规模
				remark: undefined, //备注
				relateUnits: [], //标段关联单位
				//跟踪审计单位
				GZSJDW: {
					limitId: '1382233569480044661',
					tenantId: '',
					userIds: [],
					adminUser: '',
					sign: 0,
				},
				//结算审计单位
				JSSJDW: {
					limitId: '1382233569480044661',
					tenantId: '',
					userIds: [],
					adminUser: '',
					sign: 1,
				},
				//三方巡查单位
				SFXCDW: {
					limitId: '1503941132650622977',
					tenantId: '',
					userIds: [],
					adminUser: '',
				},
				//设计单位
				SJDW: {
					limitId: '1382233569480044802',
					tenantId: '',
					userIds: [],
					adminUser: '',
				},
				//监理单位
				JLDW: {
					limitId: '1382233569480044873',
					tenantId: '',
					userIds: [],
					adminUser: '',
				},
				//施工单位
				SGDW: {
					limitId: '1382233569480044915',
					tenantId: '',
					userIds: [],
					adminUser: '',
				},
				//咨询单位
				ZXDW: {
					limitId: '1382233569480044993',
					tenantId: '',
					userIds: [],
					adminUser: '',
				},
				//主管单位
				ZGDW: {
					limitId: '1382233569480044723',
					tenantId: '',
					userIds: [],
					adminUser: '',
				},
			},
			copySectionForm: {},
			addUnitShow: false,
			moneyRule: [
				{ required: true, message: '不能为空...' },
				{
					pattern: /(^[\d]|^[1-9][\d]{0,8})($|[\.][\d]{0,4}$)/,
					message:
						'请填写正确的金额，不能为负数，小数点前最多九位,以及最多四位小数',
				},
			],
			noRequiredMoneyRule: [
				{
					pattern: /(^[\d]|^[1-9][\d]{0,8})($|[\.][\d]{0,4}$)/,
					message:
						'请填写正确的金额，不能为负数，小数点前最多九位,以及最多四位小数',
					trigger: 'change',
				},
			],
			requiredRule: [{ required: true, message: '不能为空...' }],
			numberRule: [
				{ required: true, message: '不能为空...' },
				{
					pattern: /(^[\d]|^[1-9][\d]{0,9})($|[\.][\d]{0,4}$)/,
					message: '请填写正确的数值，数字或+小数点',
				},
			],

			// 弹窗对象
			dialogObj: {
				visible: false,
				title: '',
				width: '80%',
				type: '',
				mode: 'add',
				btnLoading: false,
			},
			logData: [], //操作日志
			endDatePicker: this.processDate(),
			upUnit: '', //上传单位全称
			shortName: '', //上传单位简称
			disabled: false,
			personList: [], //标段负责人
			fullLoading: {},
			sectionId: '',
			sectionShow: false,
			showUnitList: [],
			jsUnit: [],
			allPerson: [],
			noFirst: false,
			onFirstObj: {},
			locationShow: false, //定位弹窗显隐
			locationObj: {
				address: '', //详细地址
				point: [], //坐标集合
			}, //接收的位置信息对象
			allLocation: [], // 所有的
			copyAllLocation: [],
		}
	},
	created() {
		// 获取所有的单位
		this.getCompanyList()
		// 编辑时回显
		if (this.routeQuery === 'edit') {
			this.getInfoData()
		} else {
			// 获取项目资料
			this.getDataFiles()
		}

		// 获取当前登录人公司信息
		if (this.routeQuery != 'view') {
			this.getCompanyMsg()
		}
		this.moneyForm.feeLy = this.projectDict.dxxmzjly.map((x, index) => {
			this.$set(x, 'feeDictValue', x.value)
			this.$set(x, 'feeDictName', x.sname)
			this.$set(x, 'feeValue', 0)
			this.$set(x, 'sortNum', index)
			this.$set(x, 'percent', '')
			return x
		})
		this.moneyForm.feeTr = this.projectDict.dxxmtr.map((x, index) => {
			this.$set(x, 'feeDictValue', x.value)
			this.$set(x, 'feeDictName', x.sname)
			this.$set(x, 'feeValue', 0)
			this.$set(x, 'sortNum', index)
			this.$set(x, 'percent', '')
			return x
		})
		this.copySectionForm = this.$utils.clone(this.sectionForm, true)
	},
	methods: {
		// 顶图定位
		location() {
			this.locationShow = true
			setTimeout(() => {
				if (this.$refs.ProjectMapIndex) {
					if (this.allLocation.length > 0) {
						this.$refs.ProjectMapIndex.initMap(this.allLocation)
					}
				}
			}, 300)
		},

		// 定位弹窗关闭
		locationClose() {
			this.locationShow = false
			this.locationObj = {
				address: '', //详细地址
				point: [], //坐标集合
			}
			this.allLocation = this.$utils.clone(this.copyAllLocation, true)
		},

		// 接收
		acceptPoint(data) {
			let obj = {
				address: data.address,
				point: data.point,
				type: data.type,
			}

			this.locationObj = this.$utils.clone(obj, true)
			if (obj.type == 'marker') {
				this.allLocation = []
			} else {
				this.allLocation = this.allLocation.filter(
					(x) => x.type != 'marker'
				)
			}
			this.allLocation.push(this.locationObj)
			if (data.noData) {
				this.allLocation = []
			}
		},

		// 按钮点击 取消 确认
		locationBtn(state) {
			if (state) {
				let obj = this.$utils.clone(this.locationObj, true)
				if (obj.type == 'marker') {
					this.projectInfo.address = obj.address
				}
				this.copyAllLocation = this.$utils.clone(this.allLocation, true)
				this.locationShow = false
				console.log(this.allLocation)
				console.log(this.copyAllLocation)
			} else {
				this.allLocation = this.$utils.clone(this.copyAllLocation, true)
				this.locationShow = false
			}
		},

		// 标段获取对应类型单位
		getUnit(data, type) {
			let arr = []
			let obj = {}
			arr = this.showUnitList.reduce((cur, next) => {
				obj[next.tenantId]
					? ''
					: (obj[next.tenantId] = true && cur.push(next))
				return cur
			}, [])
			arr = arr.filter((x) => x.limitId == data)
			if (
				arr.length === 1 &&
				this.dialogObj.mode === 'add' &&
				!this.noFirst
			) {
				this.$set(this.sectionForm[type], 'tenantId', arr[0].tenantId)
			}
			return arr
		},

		// 通过tenantId 获取人员
		getUnitPerson(data, type) {
			let arr = []
			arr = this.showUnitList.filter((x) => x.tenantId == data)
			if (
				type &&
				arr.length > 0 &&
				!this.onFirstObj[type] &&
				this.sectionForm[type].adminUser === ''
			) {
				this.$set(this.sectionForm[type], 'adminUser', arr[0].userId)
			}
			return arr
		},

		// 新增参建单位组件关闭
		acceptClose(data) {
			this.addUnitShow = false
		},

		// 接收人员信息
		acceptPerson(data) {
			let arr = data.filter((x) => x.isCheck)
			this.showUnitList = this.showUnitList.concat(arr)
			this.addUnitShow = false
		},

		// 项目信息参建单位change事件
		constUnitChange(data) {
			if (!data) {
				return
			}
			this.companyChange(data, '建设单位', 0)
		},

		// 新增参建单位信息
		addUnitDialog() {
			this.addUnitShow = true
			setTimeout(() => {
				this.$refs.addUnit.dialogShow = true
			}, 200)
		},

		// 编辑时查询是否可编辑基本信息
		isEditable() {
			Api.isEditable({ id: this.projectInfo.id }).then((res) => {
				if (res.data && res.data > 0) {
					this.infoDisabled = true
				}
			})
		},

		// 编辑时信息回显
		getInfoData(id, type) {
			let aid = id ? id : this.$route.query.projectId
			Api.getProjectInfo({ id: aid })
				.then((res) => {
					// console.log(res);
					this.projectInfo = res.data.projectInfo
					if (res.data.projectMap.length > 0) {
						this.allLocation = res.data.projectMap
						this.copyAllLocation = this.$utils.clone(
							this.allLocation,
							true
						)
					}
					this.projectInfo.isNorth = res.data.anlysisProject.isNorth
					this.projectInfo.newProType =
						res.data.projectInfo.newProType
					let owenrList = res.data.ownerInfo.filter((x) => x.isSelect)
					if (owenrList.length == 1) {
						// this.ownerInfo.ownerUnitItem[0] = owenrList[0]
						this.$set(this.ownerInfo.ownerUnitItem, 0, owenrList[0])
						this.showUnitList = res.data.ownerInfo.splice(
							1,
							res.data.ownerInfo.length
						)
					} else {
						this.$set(this.ownerInfo, 'ownerUnitItem', owenrList)
						this.showUnitList = res.data.ownerInfo.splice(
							2,
							res.data.ownerInfo.length
						)
					}
					this.ownerInfo.ownerUnitItem[0].require = true
					this.ownerInfo.ownerUnitItem[0].disabled = true
					this.ownerInfo.ownerUnitItem[0].adminDisabled = true

					this.showUnitList.forEach((x) => (x.isCheck = true))
					this.showUnitList = this.$utils.orderBy(this.showUnitList, [
						'limitName',
						'asc',
					])
					this.moneyForm.feeLy = res.data.dxxmzjly
					this.moneyForm.feeTr = res.data.dxxmtr

					// 项目信息是否可编辑
					this.isEditable()

					this.projectInfo.hasSerial =
						this.projectInfo.hasSerial === 1 ? 1 : 0

					// 回显标段信息
					this.getSectionData()

					// 回显资料附件
					this.getDataFiles(res.data.projectInfo.id)
					this.ownerInfo.ownerUnitItem.forEach((x, index) => {
						let arr = this.filterCompany(x.limitName)
						let obj = arr.find((y) => y.ownerUnit == x.tenantId)
						this.ownerInfo.ownerUnitItem[index].userList =
							obj.userList
						this.ownerInfo.ownerUnitItem[index].oldUserId = x.userId
						this.ownerInfo.ownerUnitItem[index].oldTenantId =
							x.tenantId
						this.ownerInfo.ownerUnitItem[index].oldAdminId =
							x.adminId
					})
				})
				.catch((err) => {})
		},

		// 根据项目ID 回显标段数据
		getSectionData() {
			this.sectionTableObj.loading = true
			Api.getSectionInfo({ projectId: this.projectInfo.id })
				.then((res) => {
					this.sectionTableObj.tableData = res.data
					this.sectionTableObj.loading = false
				})
				.catch((err) => {
					this.sectionTableObj.tableData = []
					this.sectionTableObj.loading = false
				})
		},

		// 根据项目ID 回显附件
		getDataFiles(aid) {
			let that = this
			this.dataTableObj.loading = true
			Api.getProjectFileData({
				projectId: aid || '',
				tableName: 'bus_project',
				// type: '0', //项目内上传附件使用了 type=2  所以这里要去掉
			})
				.then((res) => {
					this.dataTableObj.tableData = res.data
					this.maxLevel =
						res.data[0] && res.data[0].maxLevel
							? parseInt(res.data[0].maxLevel) + 1
							: 1
					this.curLevel = this.maxLevel

					setTimeout(() => {
						that.$refs.dataTable && that.$refs.dataTable[0]
							? that.$refs.dataTable[0].setAllTreeExpand(true)
							: ''
					}, 500)

					setTimeout(() => {
						this.dataTableObj.loading = false
					}, 300)

					// 主键ID
					if (
						this.dataTableObj.curTemplateId &&
						this.dataTableObj.curTemplateId !== ''
					) {
						let _item = this.$utils.findTree(
							res.data,
							(x) =>
								x.templateId === this.dataTableObj.curTemplateId
						)
						_item
							? (this.dataTableObj.currentId = _item.item.id)
							: ''
					}
				})
				.catch((err) => {
					this.dataTableObj.tableData = []
				})
		},

		// 切换展开层级
		changeLevel(level) {
			// 先关闭所有
			this.$refs.dataTable[0].clearTreeExpand()

			// 找到对应层级的数组
			let arr = this.$utils.filterTree(
				this.dataTableObj.tableData,
				(x) => x.level < level - 1
			)
			this.$refs.dataTable[0].setTreeExpand(arr, true)
		},

		// 根据单位类型查询单位
		getCompanyList() {
			Api.selectSysTenantsByType().then((res) => {
				this.companyList.push(res.data)
				this.$set(this, 'jsUnit', res.data.SUBJECT_JSDW)
			})
		},

		// 选中单位
		filterCompany(type) {
			// 获取单位对应的对象名称
			let objName = this.dealName(type)
			// 如果存在的话就获取对象数组 return 出去
			// 没有就返回空数组
			if (objName && objName != '') {
				let obj = this.companyList[0]
				if (obj) {
					let arr = obj[objName]
					return arr
				}
			} else {
				return []
			}
		},

		// 单位
		companyChange(e, data, index) {
			if (!e) {
				return
			}
			// change事件触发后从参建单位中过滤素出单位类型名称一斤id与当前选中的公司一样的
			let list = this.ownerInfo.ownerUnitItem.filter((x) => {
				if (x.limitName == data && x.tenantId == e) {
					return x
				}
			})
			// 如果获取到多个表示当前公司已被选中，则提醒不能重复添加
			if (list.length > 1) {
				this.$message.warning(
					`当前公司已添加到${this.dealType(data)}里，请勿重复添加！`
				)
				this.ownerInfo.ownerUnitItem[index].tenantId = ''
			} else {
				let arr = this.filterCompany(data)
				let obj = arr.find((x) => x.ownerUnit == e)
				this.ownerInfo.ownerUnitItem[index].limitId = obj.limitId
				this.ownerInfo.ownerUnitItem[index].userList = obj.userList
				this.ownerInfo.ownerUnitItem[index].sname = obj.sname
				this.ownerInfo.ownerUnitItem[index].userId = ''
				this.ownerInfo.ownerUnitItem[index].adminId = ''
				this.ownerInfo.ownerUnitItem[index].phone = ''
				this.ownerInfo.ownerUnitItem[index].adminPhone = ''
				if (index == 0 && !this.infoDisabled) {
					this.projectInfo.constructionUnit = e
					this.ownerInfo.ownerUnitItem[index].tenantId = e
					let obj = this.jsUnit.find((x) => x.ownerUnit == e)
					this.currentArea = obj.area
					this.projectInfo.isNorth = obj.area
				}
				if (index == 0 || index == 1) {
					this.showUnitList.forEach((x) => {
						if (x.limitName == data && x.tenantId != e) {
							x.needfilter = true
						}
					})
					this.showUnitList = this.showUnitList.filter(
						(x) => !x.needfilter
					)
				}
				if (index == 1) {
					let arr = this.ownerInfo.ownerUnitItem[index]
					arr.userId = arr.userList[0].id
					arr.phone = arr.userList[0].phone
				}
			}
		},

		// 清除当前选中公司
		clearCompany(index) {
			this.ownerInfo.ownerUnitItem[index].limitId = ''
			this.ownerInfo.ownerUnitItem[index].userList = ''
			this.ownerInfo.ownerUnitItem[index].sname = ''
			this.ownerInfo.ownerUnitItem[index].userId = ''
			this.ownerInfo.ownerUnitItem[index].phone = ''
			this.ownerInfo.ownerUnitItem[index].leaderName = ''
			this.ownerInfo.ownerUnitItem[index].adminId = ''
			this.ownerInfo.ownerUnitItem[index].adminName = ''
			this.ownerInfo.ownerUnitItem[index].adminPhone = ''
			if (index == 0) {
				this.projectInfo.isNorth = ''
				this.projectInfo.constructionUnit = ''
				this.currentArea = ''
			}
		},

		// 移除人员
		removePerson(row, index) {
			if (row.roleId) {
				this.$confirm(
					'该单位人员无法进行移除，在项目中已有相关角色任务权限。',
					'提示',
					{
						type: 'warning',
						showCancelButton: false,
						showConfirmButton: false,
					}
				)
				return
			}
			let msg =
				`是否确认移除 ${row.sname} ${row.leaderName} 一旦移除，` +
				`${row.leaderName} 将无法进入项目中进行操作。`
			this.$confirm(msg, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					if (row.isNewUserId == '0') {
						this.removeApi(row)
					}
					this.showUnitList.splice(index, 1)
					this.$message.success('移除成功!')
				})
				.catch(() => {
					this.$message.info('已取消移除')
				})
		},

		// 移除人员调接口
		removeApi(data) {
			this.sectionTableObj.loading = true
			Api.delectObsUnitOrUser({
				projectId: this.projectInfo.id,
				tenantId: data.tenantId || data.oldTenantId,
				limitId: data.limitId || '1382233569480044546',
				userId: data.userId || data.oldUserId,
			})
				.then((res) => {
					this.getSectionData()
				})
				.catch(() => {
					this.sectionTableObj.loading = false
				})
		},

		// 获取当前企业用户
		getUserList(data) {
			return data
		},

		// 用户选择
		userChange(data, index) {
			if (!data) {
				return
			}
			let obj = this.ownerInfo.ownerUnitItem[index]
			let list = obj.userList.find((x) => x.id == data)
			this.ownerInfo.ownerUnitItem[index].phone = list.phone
			this.ownerInfo.ownerUnitItem[index].leaderName = list.sname
			let _index = this.showUnitList.findIndex((x) => {
				if (
					x.tenantId == obj.tenantId &&
					list.id == x.userId &&
					x.limitId == obj.limitId
				) {
					return x
				}
			})
			if (_index > -1) {
				this.showUnitList.splice(_index, 1)
			}
		},

		// 项目管理员change事件
		userChangeAdmin(data, index) {
			if (!data) {
				return
			}
			let obj = this.ownerInfo.ownerUnitItem[index]
			let list = obj.userList.find((x) => x.id == data)
			this.ownerInfo.ownerUnitItem[index].adminPhone = list.phone
			this.ownerInfo.ownerUnitItem[index].adminName = list.sname
			let _index = this.showUnitList.findIndex((x) => {
				if (
					x.tenantId == obj.tenantId &&
					list.id == x.userId &&
					x.limitId == obj.limitId
				) {
					return x
				}
			})
			if (_index > -1) {
				this.showUnitList.splice(_index, 1)
			}
		},

		// 清除人员
		clearAdmin(index) {
			this.ownerInfo.ownerUnitItem[index].adminId = ''
			this.ownerInfo.ownerUnitItem[index].adminName = ''
			this.ownerInfo.ownerUnitItem[index].adminPhone = ''
		},

		// 更换管理员
		changAdmin(data) {
			this.$set(data, 'adminDisabled', !data.adminDisabled)
			this.$forceUpdate()
		},

		// 清除人员
		clearPerson(index) {
			this.ownerInfo.ownerUnitItem[index].userId = ''
			this.ownerInfo.ownerUnitItem[index].phone = ''
			this.ownerInfo.ownerUnitItem[index].leaderName = ''
		},

		// 标段内用户选择
		userChange1(data) {
			let arr = this.personList
			let obj = arr.find((x) => x.userId == data)
			this.sectionForm.constract = obj?.phone
		},

		// 点击上传文件、查看文件
		addData(row, mode) {
			this.dialogObj.title = mode === 'add' ? '添加资料' : '查看资料'
			this.dialogObj.mode = mode
			this.dialogObj.width = '80%'
			this.dialogObj.type = 'file'

			// 判断有没有填写信息
			if (!this.projectInfo.id) {
				this.dataTableObj.curTemplateId = row.templateId
				this.doSave('hideData', 'hideData')
				// this.$message.warning('请先保存项目信息后再上传项目资料！')
				return
			}

			this.dataTableObj.currentId = row.id
			this.dialogObj.visible = true
		},

		// 标段 新增、编辑、删除、报审
		async handleSection(type, row) {
			switch (type) {
				// 如果是新增标段，保存当前信息
				case 'add':
					// 判断有没有填写信息
					this.disabled = false
					this.doSave('hideMessage', 'add')
					this.getPerson()
					this.dialogObj.mode = type

					// 建设单位
					let _jsdw = this.ownerInfo.ownerUnitItem.find(
						(x) => x.limitId === '1382233551767498754'
					)

					// 标段负责人  默认建设单位负责人
					this.sectionForm.packPrincipal = _jsdw ? _jsdw.adminId : ''
					this.userChange1(this.sectionForm.packPrincipal)
					return
				case 'edit': // 编辑
					this.disabled = true
					this.dialogObj.mode = type
					this.getPerson()
					// 为了能够重置表单
					this.$nextTick(() => {
						this.$refs.ownerForm[0].validate((valid) => {
							if (valid) {
								this.doSave('hideMessage', 'edit', row)
							} else {
								this.$message.error('请完善参建单位信息！')
							}
						})
					})
					this.sectionForm.state = row.state

					break
				case 'delete': // 删除
					this.sectionTableObj.loading = true
					let status = await this.$deleteConfirm('该标段')
					if (status) {
						Api.getPackTaskNum({
							packId: row.id,
						}).then((res) => {
							if (res.data == 0) {
								Api.deleteSection({ id: row.id })
									.then((res) => {
										this.sectionTableObj.loading = false
										// 重载标段表格
										this.getSectionData()
									})
									.catch((err) => {
										this.sectionTableObj.loading = false
									})
							} else {
								this.sectionTableObj.loading = false
								this.$message.warning(
									'该标段已委托审计，无法删除！'
								)
							}
						})
					} else {
						this.sectionTableObj.loading = false
					}
					break
			}
		},

		// 标段内单位change事件
		sectionChange(data) {
			this.sectionForm[data].userIds = []
			this.sectionForm[data].adminUser = ''
			this.noFirst = true
			this.$forceUpdate()
		},

		// 负责人change 事件
		adminUserChange(type) {
			this.onFirstObj[type] = true
			this.$forceUpdate()
		},

		dealType(type) {
			// 获取单位类型 名称
			let obj = this.projectDict.dwlx.find((x) => x.sname == type)
			if (obj) {
				return obj.sname
			}
		},

		// 处理
		dealName(type) {
			let msg = ''
			switch (type) {
				case '设计单位':
					msg = 'SUBJECT_SHEJIDW'
					break
				case '代建单位':
					msg = 'SUBJECT_DJDW'
					break
				case '建设单位':
					msg = 'SUBJECT_JSDW'
					break
				case '施工单位':
					msg = 'SUBJECT_SGDW'
					break
				case '咨询单位':
					msg = 'SUBJECT_ZXDW'
					break
				case '监理单位':
					msg = 'SUBJECT_JLDW'
					break
				case '主管单位':
					msg = 'SUBJECT_ZGDW'
					break
			}
			return msg
		},

		// 弹窗确认
		async doSubmit(state) {
			this.dialogObj.btnLoading = true
			switch (this.dialogObj.type) {
				case 'file':
					this.$refs.fileUpload.fileSend(
						this.dataTableObj.currentId,
						this.projectInfo.id,
						() => {
							this.$message.success('上传成功！')
							this.doCancel()
						},
						() => {
							this.doCancel()
						}
					)
					break
				case 'section':
					let params = this.$utils.clone(this.sectionForm, true)
					params.projectId = this.projectInfo.id
					params.auditId = this.projectInfo.auditId
					params.tenantId = this.tenantId
					params.state = state
					let list = [
						'GZSJDW',
						'JSSJDW',
						'SFXCDW',
						'SJDW',
						'JLDW',
						'SGDW',
						'ZXDW',
						'ZGDW',
					]
					Object.keys(params).map((x) => {
						if (list.includes(x)) {
							params[x].userIds =
								params[x].userIds.join(',') || ''
							if (
								params[x].adminUser == '' ||
								params[x].tenantId == ''
							) {
								delete params[x]
							}
						}
					})
					this.$refs.sectionForm.validate((valid) => {
						if (valid) {
							Api.saveOrUpdateSection(params)
								.then((res) => {
									this.doCancel()
									this.getInfoData(this.projectInfo.id)
								})
								.catch((err) => {
									this.dialogObj.btnLoading = false
									return false
								})
						} else {
							this.$message.error('请完善表单！')
							this.dialogObj.btnLoading = false
							return false
						}
					})
					break
			}
		},

		// 弹窗取消
		doCancel() {
			switch (this.dialogObj.type) {
				case 'file':
					this.dataTableObj.currentId = ''
					this.dataTableObj.curTemplateId = ''
					// 重载附件
					this.getDataFiles(this.projectInfo.id)
					break
				case 'section':
					this.sectionForm = this.$utils.clone(
						this.copySectionForm,
						true
					)
					this.noFirst = false
					this.onFirstObj = {}
					this.sectionForm.status = false
					break
			}
			this.dialogObj.visible = false
			this.dialogObj.title = ''
			this.dialogObj.width = ''
			this.dialogObj.type = ''
			this.dialogObj.mode = ''
			this.dialogObj.btnLoading = false
		},

		// 点击保存（新增、编辑项目）
		doSave(hideMessage, type, row) {
			let params = {
				projectInfo: this.$utils.clone(this.projectInfo),
				ownerInfo: this.$utils.clone(this.showUnitList, true),
				projectFile: $deepCopy(this.dataTableObj.tableData, 'Array'),
				projectFee: this.moneyForm.feeTr.concat(this.moneyForm.feeLy),
				projectMap: [],
			}

			// 格式化 计划开工时间 和 计划竣工时间
			let startDate = params.projectInfo.planStartTime
			let endDate = params.projectInfo.planEndTime
			params.projectInfo.planStartTime = this.$utils.toDateString(
				startDate,
				'yyyy-MM-dd'
			)
			params.projectInfo.planEndTime = this.$utils.toDateString(
				endDate,
				'yyyy-MM-dd'
			)

			params.projectInfo.sname =
				params.projectInfo.sname && params.projectInfo.sname !== ''
					? params.projectInfo.sname.trim()
					: ''

			if (!params.projectInfo.address) {
				this.$message.error('请填写项目位置')
				return
			}

			// 参建单位信息操作
			params.ownerInfo.forEach((x, index) => {
				x.sort = index
			})
			// 项目总投资
			params.projectInfo.proTotalValue = this.moneyForm.proTotalValue
			// 项目总来源资金
			params.projectInfo.proTotalInvestment =
				this.moneyForm.proTotalInvestment

			// 下拉框选择的两个单位
			let unitList = this.$utils.clone(this.ownerInfo.ownerUnitItem, true)
			// 代建单位如果没选择单位那么不传到后台
			let _index = unitList.findIndex((x) => x.tenantId == '')
			if (_index > -1) {
				let handlerObj = this.$utils.clone(unitList[_index], true)
				if (this.routeQuery === 'edit') {
					this.removeApi(handlerObj)
				}
				unitList.splice(_index, 1)
			}
			// 将下拉的和弹窗选择的合并到一个数组(下拉的在前面)
			for (let i = unitList.length - 1; i >= 0; i--) {
				params.ownerInfo.unshift(unitList[i])
			}
			params.ownerInfo.forEach((x, index) => {
				x.sortNum = index
				if (!x.isSelect) {
					// 不是下拉的 isSelect 赋予 0
					x.isSelect = 0
				}
			})
			// 项目封面
			// let fileList = []
			// if (this.routeQuery === 'add') {
			// 	fileList = this.$refs.coverUpload[0].addList
			// } else {
			// 	fileList = this.$refs.coverUpload[0].fileList
			// 	if (fileList.length == 0) {
			// 		fileList = this.$refs.coverUpload[0].addList
			// 	}
			// }
			// if (fileList.length === 0) {
			// 	this.$message.warning('请上传项目封面！')
			// 	return
			// }
			let status = false
			this.$refs.projectForm[0].validate((valid) => {
				if (!valid) {
					return false
				} else {
					this.$refs.projectMoneyForm[0].validate((valid) => {
						if (!valid) {
							return false
						} else {
							this.$refs.ownerForm[0].validate((valid) => {
								if (!valid) {
									return false
								} else {
									status = true
								}
							})
						}
					})
				}
			})

			// 编号及原因处理
			params.projectInfo.hasSerial === 1
				? (params.projectInfo.reason = '')
				: (params.projectInfo.assignNo = '')

			// 长度
			params.projectInfo.lengthSign
				? ''
				: (params.projectInfo.length = null)

			// 建筑面积
			params.projectInfo.floorageSign
				? ''
				: (params.projectInfo.floorage = null)

			// 地图类型
			params.projectInfo.mapType = 0

			let mapObj = this.$utils.clone(this.allLocation, true)
			if (mapObj.length > 0) {
				mapObj.map((x) => {
					x.point.map((y, index) => {
						y.sort = index
					})
					let { address, point, type } = x
					params.projectMap.push({ address, point, type })
				})
			}

			if (status) {
				if (hideMessage && hideMessage == 'save') {
					this.btnLoading = true
				}
				if (!!type) {
					this.fullLoading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)',
					})
				}
				Api.saveOrUpdateProject(params)
					.then((res) => {
						if (res.operationCode != 1 || res.msg == 'faild') {
							this.btnLoading = false
							this.$message.error(res.data)
							return
						}
						// 上传资料附件
						this.fileSend(
							res.data.id,
							this.fileList,
							this.dataTableObj.tableData,
							'project'
						)
						if (type == 'edit') {
							// 回显信息
							this.getInfoData(res.data.id, '')
						} else {
							// 回显信息
							this.getInfoData(res.data.id, 'section')
						}

						if (hideMessage && hideMessage === 'hideMessage') {
							this.$refs.coverUpload[0].fileSend(
								res.data.id,
								res.data.id,
								() => {
									this.$refs.coverUpload[0].addList = []
								},
								() => {}
							)
							this.dialogObj.visible = true
							this.dialogObj.title =
								type == 'edit' ? '编辑标段' : '新增标段'
							this.dialogObj.width = '80%'
							this.dialogObj.type = 'section'
							this.btnLoading = false
							this.fullLoading.close()
							if (type == 'edit') {
								this.$nextTick(() => {
									let obj = this.$utils.clone(row, true)
									obj.oldPackPrincipal = obj.packPrincipal
									Object.keys(this.sectionForm).map((x) => {
										obj.obsMaps.forEach((y) => {
											if (
												this.sectionForm[x]?.limitId ==
												y.limitId
											) {
												let obj = {
													limitId: y.limitId,
													tenantId: y.tenantId,
													adminUser: y.adminUser,
													userIds:
														y.userIds == ''
															? []
															: y.userIds.split(
																	','
															  ),
												}
												if (y.sign === null) {
													this.sectionForm[x] = obj
													return
												}
												if (
													y.sign ==
													this.sectionForm[x].sign
												) {
													this.sectionForm[x] = obj
												}
											}
										})
									})
									Object.keys(this.sectionForm).forEach(
										(x) => {
											Object.keys(obj).forEach((y) => {
												if (x == y) {
													this.sectionForm[x] = obj[y]
												}
											})
										}
									)
									this.sectionForm.id = obj.id
								})
							}
							return true
						} else if (hideMessage && hideMessage === 'hideData') {
							this.$refs.coverUpload[0].fileSend(
								res.data.id,
								res.data.id,
								() => {
									this.$refs.coverUpload[0].addList = []
									this.dialogObj.visible = true
									this.fullLoading
										? this.fullLoading.close()
										: ''
								},
								() => {
									this.btnLoading = false
									this.fullLoading
										? this.fullLoading.close()
										: ''
								}
							)
						} else {
							this.$refs.coverUpload[0].fileSend(
								res.data.id,
								res.data.id,
								() => {
									this.backHome()
								},
								() => {
									this.btnLoading = false
								}
							)
						}
						this.$message.success('保存成功！')
						this.btnLoading = false
					})
					.catch((err) => {
						this.btnLoading = false
						this.fullLoading ? this.fullLoading.close() : ''
						return false
					})
			} else {
				this.btnLoading = false
				this.$message.warning('请完善表单信息！')
			}
		},

		// 点击取消返回上一页
		backHome() {
			let obj = this.$getSessionItem('activeMenu')
				? JSON.parse(this.$getSessionItem('activeMenu'))
				: { path: '/404' }
			// 设置返回状态
			this.$router.replace({
				path: '/redirect' + obj.path,
			})
		},

		// 文件上传到服务器
		fileSend(aid, arr, list, from) {
			let that = this
			if (arr.length > 0) {
				for (let item of arr) {
					let formData = new FormData()
					formData.append('file', item)
					formData.append('path', dayjs().format('YYYY-MM-DD'))
					formData.append('output', 'json')

					UploadApi.uploadToWeb(formData)
						.then((res) => {
							that.fileUpload(aid, res, item, list, from)
						})
						.catch((err) => {
							that.$message.error('附件上传服务器失败！')
							return false
						})
				}
			}
		},

		// 文件上传方法 --- 上传数据库
		fileUpload(uploadId, params, item, list, from) {
			// 在有上传数据的情况下
			// let _aid = uploadId ? uploadId : this.aid
			let _aid = uploadId
			let _item = list.find((x) => x.keyId === item.uid)

			let dataParams = {
				path: params.path,
				md5: params.md5,
				size: params.size,
				aid: _aid,
				source: _item.source, // 资源类型
				supSourceName: _item.supSourceName,
				fileSource: _item.fileSource,
				tableName: _item.tableName,
				assortment: _item.assortment,
				projectId: from == 'project' ? _aid : this.projectInfo.id,
				upUnit: _item.upUnit,
				shortName: _item.shortName,
			}
			from == 'project' ? '' : (dataParams.packageId = _aid)
			UploadApi.saveFile(dataParams).then((res) => {})
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.projectInfo.planStartTime
					if (startTime.constructor == String) {
						startTime = startTime.substring(0, 19)
						startTime = startTime.replace(/-/g, '/')
						startTime = new Date(startTime)
					}
					if (startTime) {
						return startTime.getTime() > time.getTime() - 1000000
					}
				},
			}
		},

		// 时间处理
		timeChange(data) {
			if (!data) {
				return
			}
			this.projectInfo.striveStartDate = data.getFullYear() + ''
			if (this.projectInfo.planEndTime != '') {
				let date = ''
				let timestamp = ''
				if (this.projectInfo.planEndTime.constructor == String) {
					date = this.projectInfo.planEndTime
					date = date.substring(0, 19)
					date = date.replace(/-/g, '/')
					timestamp = new Date(date).getTime()
				} else {
					timestamp = this.projectInfo.planEndTime
				}
				if (data.getTime() >= timestamp) {
					this.projectInfo.planEndTime = ''
					this.$message.error(
						'开工时间不能超过竣工时间，且不能为同一天！'
					)
				}
			}
		},

		// 获取当前登录人公司信息
		getCompanyMsg() {
			Api.selectTenantInformation({
				tenantId: this.$getSessionItem('tenantId'),
			})
				.then((res) => {
					if (this.routeQuery == 'add') {
						let limitId = this.$getSessionItem('limitId')
						if (limitId != '1382233551767498754') {
							return
						}
						this.projectInfo.isNorth = res.data.area
						this.currentArea = res.data.area
						let obj = res.data.userList.find(
							(x) => x.id == res.data.userId
						)
						let currentLimitId = this.$getSessionItem('limitId')
						let jsObj = {
							tenantId: res.data.tenantId,
							limitName: '建设单位',
							limitId: currentLimitId,
							userId: res.data.userId,
							userList: res.data.userList,
							phone: obj.phone,
							sname: res.data.unitName,
							leaderName: obj.sname,
							adminId: res.data.userId,
							adminName: obj.sname,
							adminPhone: obj.phone,
							require: true,
							isSelect: 1,
						}
						this.$set(this.ownerInfo.ownerUnitItem, 0, jsObj)
						setTimeout(() => {
							let unit = this.jsUnit.find(
								(x) => x.ownerUnit == res.data.tenantId
							)
							this.projectInfo.constructionUnit = unit.ownerUnit
						}, 200)
					}
					this.upUnit = res.data.unitName
					this.shortName = res.data.shortName
				})
				.catch(() => {
					this.ownerInfo.ownerUnitItem[0].tenantId = ''
					this.ownerInfo.ownerUnitItem[0].limitId = ''
					this.ownerInfo.ownerUnitItem[0].userId = ''
					this.upUnit = ''
					this.shortName = ''
				})
		},

		//项目归属区域change事件
		areaChange(data) {
			if (data != this.currentArea) {
				this.$message.warning('跟建设单位项目归属区域不一致！')
			}
		},

		// 获取区域名称
		getAreaName(data) {
			let obj = this.projectDict.xmgsqy.find((x) => x.value == data)
			let name = obj.sname
			return name
		},

		// 参建单位人员
		getPerson() {
			getUserTenantTablePageListByTenantId({
				size: 1000,
				current: 1,
				tenantId: this.ownerInfo.ownerUnitItem[0].tenantId,
			}).then((res) => {
				this.personList = res.data.records

				if (this.sectionForm.packPrincipal) {
					this.userChange1(this.sectionForm.packPrincipal)
				}
			})
		},

		// 查看标段
		viewSection(data) {
			this.sectionShow = true
			this.sectionId = data.id
			setTimeout(() => {
				this.$refs.SectionLook.dialogObj.show = true
			}, 200)
		},

		// 暂无此内容
		contentChange(data) {
			// 判断有没有填写信息
			if (!this.projectInfo.id) {
				data.noSuchContent = 0
				this.$message.error('请先保存项目信息')
				return
			}
			Api.updateProjectFileNodeState({
				noSuchContent: data.noSuchContent ? 1 : 0,
				id: data.id,
			}).then((res) => {})
		},

		// 项目信息暂无此内容change
		noContent(type) {
			this.$refs.projectForm[0].clearValidate(type)
		},
	},
	computed: {
		// 码表
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
			tenantId: (state) => state.tenantId,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		routeQuery() {
			return this.$route.query.type
		},

		// 如果有标段委托，项目信息不可编辑
		isDisabled() {
			return this.$route.query.packAudit == 1
		},

		// 要展示的 card
		cardShowList() {
			let menu = this.$route.query.menu
			let arr = this.cardList.concat()

			switch (menu) {
				case 'project':
					arr = arr.splice(0, 6)
					break
				default:
			}

			return arr
		},

		// 计算总投资额
		trMoneyChange() {
			let total = 0
			this.moneyForm.feeTr.map((x) => {
				let money = parseFloat(x.feeValue) || 0
				total = this.$utils.add(total, money)
			})
			this.moneyForm.proTotalValue = total
			this.moneyForm.feeTr.forEach((x) => {
				let _num = this.$utils.divide(x.feeValue, total)
				x.percent = (_num * 100).toFixed(2)
			})
		},

		// 计算项目总来源资金
		lyMoneyChange() {
			let total = 0
			this.moneyForm.feeLy.map((x) => {
				let money = parseFloat(x.feeValue) || 0
				total = this.$utils.add(total, money)
			})
			this.moneyForm.proTotalInvestment = total
			this.moneyForm.feeLy.forEach((x) => {
				let _num = this.$utils.divide(x.feeValue, total)
				x.percent = (_num * 100).toFixed(2)
			})
		},
	},
	watch: {
		// 合同工期
		'sectionForm.duration': {
			handler(val) {
				if (val.length > 6) {
					this.$message.error('最长6位')
					this.sectionForm.duration = val.substr(0, 6)
				}
			},
		},
		// 标段建安工程概算价
		'sectionForm.estimatePrice': {
			handler(val, oldval) {
				let moneyTotal = this.projectInfo.buget //项目建安工程概算价
				if (parseFloat(moneyTotal) < parseFloat(val)) {
					this.sectionForm.estimatePrice = oldval
					this.$message.error(
						`标段建安工程概算价不能超过项目建安工程概算价（${moneyTotal} 万元）！`
					)
				}
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="less">
.project-info-main {
	.info-content {
		padding: 10px;
	}

	.info-content .el-row {
		border-bottom: 1px solid #dcdcdc;
		padding: 10px 0;
	}

	.info-content .border-style {
		border-bottom: 1px dashed #60adf9;
	}

	.box-header {
		margin-bottom: 10px;
	}

	.tips-header {
		font-size: 12px;
		color: #2671cc;
		font-weight: 400;
		height: 36px;
	}

	.right-btns {
		position: absolute;
		right: 0;
		top: 66px;
		padding: 0 10px;
		background-color: #fff;
		z-index: 10;
	}

	/deep/ .el-form-item--small.el-form-item {
		margin-bottom: 15px !important;
	}

	.s-input {
		/deep/ .el-input__inner {
			padding-right: 70px !important;
		}
	}
	.special-input {
		/deep/ .el-input__inner {
			padding-right: 80px !important;
		}
	}
}
.custom-disabled {
	// background-color: transparent !important;
	// border-color: transparent !important;
	// color: #909399 !important;
	margin: 0 auto;
	padding-left: 0;
	padding-right: 0;
}
.border-top {
	padding-top: 20px;
	margin-top: 20px;
	border-top: 3px dotted #eee;
}
.custom-row-section {
	.el-row + .el-row {
		border-top: 2px dashed #58a3f7;
		padding-top: 15px;
	}
}
.btn {
	height: 40px !important;
	padding: 0 50px !important;
}
.moneyNum {
	/deep/.el-input__inner {
		padding-right: 10px !important;
	}
	/deep/ .el-input__suffix {
		right: 30px !important;
	}
}
.elHeight {
	/deep/ .el-dialog__body {
		max-height: 700px !important;
	}
}
</style>
